var _objectSpread = require("D:/workspace/uat/platform-uat/Platform-foundation-pc/node_modules/@babel/runtime/helpers/objectSpread2").default;
var _objectWithoutProperties = require("D:/workspace/uat/platform-uat/Platform-foundation-pc/node_modules/@babel/runtime/helpers/objectWithoutProperties").default;
var _excluded = ["class", "staticClass", "style", "staticStyle", "attrs"];
require("core-js/modules/es.array.concat.js");
module.exports = {
  functional: true,
  render: function render(_h, _vm) {
    var _c = _vm._c,
      _v = _vm._v,
      data = _vm.data,
      _vm$children = _vm.children,
      children = _vm$children === void 0 ? [] : _vm$children;
    var classNames = data.class,
      staticClass = data.staticClass,
      style = data.style,
      staticStyle = data.staticStyle,
      _data$attrs = data.attrs,
      attrs = _data$attrs === void 0 ? {} : _data$attrs,
      rest = _objectWithoutProperties(data, _excluded);
    return _c('svg', _objectSpread({
      class: [classNames, staticClass],
      style: [style, staticStyle],
      attrs: Object.assign({
        "width": "20",
        "height": "20",
        "xmlns": "http://www.w3.org/2000/svg"
      }, attrs)
    }, rest), children.concat([_c('path', {
      attrs: {
        "d": "M10 16.25c-3.056 0-5.782-1.928-8.172-5.695a1.034 1.034 0 010-1.11C4.218 5.678 6.944 3.75 10 3.75c3.056 0 5.782 1.928 8.172 5.695.215.339.215.771 0 1.11-2.39 3.767-5.116 5.695-8.172 5.695zM10 5c-2.53 0-4.872 1.638-7.034 5C5.128 13.362 7.47 15 10 15c2.53 0 4.872-1.638 7.034-5C14.872 6.638 12.53 5 10 5zm0 7.917c-1.625 0-2.943-1.306-2.943-2.917 0-1.61 1.318-2.917 2.943-2.917S12.943 8.39 12.943 10c0 1.61-1.318 2.917-2.943 2.917zm0-1.25c.929 0 1.682-.747 1.682-1.667S10.929 8.333 10 8.333c-.929 0-1.682.747-1.682 1.667s.753 1.667 1.682 1.667z",
        "fill": "var(--mainColor)",
        "fill-rule": "nonzero"
      }
    })]));
  }
};